import { useFormContext } from 'react-hook-form';

export const useInventoryFormHandler = () => {
  const { setValue, watch, formState } = useFormContext();
  const { errors, touchedFields } = formState;

  const onChange = (fieldName: string, value: string | boolean | object) => {
    setValue(fieldName, value, { shouldDirty: true, shouldTouch: true });
  };

  const onBlur = (fieldName: string, value: string) => {
    if (touchedFields[fieldName]) {
      onChange(fieldName, value);
    }
  };

  return { onChange, onBlur, watch, errors, touchedFields };
};
